import clsx from "clsx";
import { MouseEventHandler, ReactNode, forwardRef } from "react";

export enum TagColor {
  GREEN = "GREEN",
  GRAY = "GRAY",
  LIGHT_GRAY = "LIGHT_GRAY",
  RED = "RED",
  ORANGE = "ORANGE",
  PURPLE = "PURPLE",
  DEFAULT = "DEFAULT",
  BLUE = "BLUE",
}

export interface TagProps {
  tag: ReactNode;
  color?: TagColor;
  title?: string;
  onClose?: MouseEventHandler<HTMLDivElement>;
  className?: string;
  size?: "xs" | "sm" | "md";
}

const Tag = forwardRef<HTMLDivElement, TagProps>(({ tag, title, color, className, onClose, size = "sm" }, tagRef) => (
  <div
    ref={tagRef}
    title={title}
    className={clsx(
      "inline-block",
      "font-medium leading-4",
      {
        "text-2xs rounded-sm px-1 py-0.5": size === "xs",
        "text-xs rounded-sm px-1.5 py-0.5": size === "sm",
        "text-xs md:text-sm px-2 py-1 rounded-lg md:px-3 md:py-1.5": size === "md",
      },
      {
        "bg-background-badge-red text-text-accent-red": color === TagColor.RED,
        "bg-background-badge-orange text-text-accent-amber": color === TagColor.ORANGE,
        "bg-background-badge-green text-text-accent-green": color === TagColor.GREEN,
        "bg-background-badge-purple text-text-accent-brand-purple-primary": color === TagColor.PURPLE,
        "bg-background-badge-blue text-text-accent-blue": color === TagColor.DEFAULT || color === TagColor.BLUE,
        "bg-background-badge-grey-accent text-white": color === TagColor.GRAY,
        "bg-background-badge-grey text-[#727880]": color === TagColor.LIGHT_GRAY || !color,
      },
      className
    )}
  >
    <div className="flex text-nowrap" role="alert">
      {tag}
      {onClose && (
        <div onClick={onClose} className="cursor-pointer" data-testid="remove-label">
          <i className="ml-1 icon-lt-close-line" />
        </div>
      )}
    </div>
  </div>
));

Tag.displayName = "Tag";

export { Tag };
